var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0508 2.91406V16.4764",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19141 6.30469L15.9368 13.0859",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19141 13.0783L15.91 6.3125",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98162 4.94824L6.9988 7.99977L3.94727 8.67789",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94727 10.7119L6.9988 11.39L5.98162 14.4416",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1187 4.94824L13.1016 7.99977L16.1531 8.67789",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1531 10.7119L13.1016 11.39L14.1187 14.4416",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 3.93164L10.05 5.966L12.0843 3.93164",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 15.4592L10.05 13.4248L12.0843 15.4592",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeze);
export default __webpack_public_path__ + "static/media/freeze.6c8f8db1d093e44cee311a903d5df3c7.svg";
export { ForwardRef as ReactComponent };